export const AREA_PADRAO_PAVER_MM2 = 5674.5;
export const DIAMETRO_PADRAO_PAVER_MM = 85;

const STUDENT_PADRAO = {
  6: 0.92,
  7: 0.906,
  8: 0.896,
  9: 0.889,
  10: 0.883,
  12: 0.876,
  14: 0.87,
  16: 0.866,
  18: 0.863,
  20: 0.861,
  22: 0.859,
  24: 0.858,
  26: 0.856,
  28: 0.855,
  30: 0.854,
  32: 0.842,
};

export function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return 0;
  return Number(String(valor).replace(",", "."));
}

export function numeroBR(valor, casas = 1) {
  if (valor === "" || valor === null || valor === undefined) return "";
  const n = numero(valor);
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

export function calcularAreaPorDiametro(diametroMm = DIAMETRO_PADRAO_PAVER_MM) {
  const diametro = numero(diametroMm) || DIAMETRO_PADRAO_PAVER_MM;
  return (Math.PI * Math.pow(diametro, 2)) / 4;
}

export function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = dataISO.split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

export function calcularIdadeDias(dataFabricacao, dataEnsaio) {
  if (!dataFabricacao || !dataEnsaio) return "";
  const inicio = new Date(`${dataFabricacao}T00:00:00`);
  const fim = new Date(`${dataEnsaio}T00:00:00`);
  const diff = fim.getTime() - inicio.getTime();
  if (!Number.isFinite(diff)) return "";
  return Math.max(0, Math.round(diff / 86400000));
}

export function novoCorpoProva(index) {
  return {
    cp: String(index + 1),
    largura: "",
    comprimento: "",
    altura: "",
    massa: "",
    cargaRupturaTf: "",
    forcaRupturaKn: "",
    fatorMultiplicador: "1,00",
    resistenciaRupturaMpa: "",
  };
}

export function criarCorposProva(quantidade = 10) {
  return Array.from({ length: Number(quantidade) || 10 }, (_, index) => novoCorpoProva(index));
}

export function calcularCorpoProva(item, areaMm2 = AREA_PADRAO_PAVER_MM2) {
  const cargaTexto = String(item.cargaRupturaTf ?? "").trim();
  const cargaComDecimal = /^-?\d+[,.]\d+/.test(cargaTexto);
  if (!cargaComDecimal) {
    return {
      ...item,
      forcaRupturaKn: "",
      resistenciaRupturaMpa: "",
    };
  }

  const cargaTf = numero(item.cargaRupturaTf);
  const fator = numero(item.fatorMultiplicador || 1) || 1;
  const area = numero(areaMm2) || AREA_PADRAO_PAVER_MM2;
  const forcaKn = cargaTf ? cargaTf * 9.80665 : 0;
  const resistencia = forcaKn ? ((forcaKn * 1000) / area) * fator : 0;

  return {
    ...item,
    forcaRupturaKn: forcaKn ? forcaKn.toFixed(3) : "",
    resistenciaRupturaMpa: resistencia ? resistencia.toFixed(1) : "",
  };
}

export function calcularCorposProva(lista = [], areaMm2 = AREA_PADRAO_PAVER_MM2) {
  return lista.map((item) => calcularCorpoProva(item, areaMm2));
}

export function calcularResumo(corposProva = [], coeficienteStudent = "") {
  const resistencias = corposProva
    .map((item) => numero(item.resistenciaRupturaMpa))
    .filter((valor) => Number.isFinite(valor) && valor > 0);

  if (!resistencias.length) {
    return {
      media: "",
      desvioPadrao: "",
      coeficienteStudent: coeficienteStudent || "",
      fpkEstimado: "",
    };
  }

  const media = resistencias.reduce((total, valor) => total + valor, 0) / resistencias.length;
  const variancia =
    resistencias.length > 1
      ? resistencias.reduce((total, valor) => total + Math.pow(valor - media, 2), 0) /
        (resistencias.length - 1)
      : 0;
  const desvioPadrao = Math.sqrt(variancia);
  const quantidadeCp = corposProva.length || resistencias.length;
  const quantidadeTabela = Object.keys(STUDENT_PADRAO)
    .map(Number)
    .sort((a, b) => a - b)
    .reduce((selecionado, quantidade) => {
      return quantidade <= quantidadeCp ? quantidade : selecionado;
    }, 6);
  const student =
    coeficienteStudent !== "" && coeficienteStudent !== null && coeficienteStudent !== undefined
      ? numero(coeficienteStudent)
      : STUDENT_PADRAO[quantidadeTabela] ?? 0.92;
  const fpkEstimado = media - student * desvioPadrao;

  return {
    media: media.toFixed(1),
    desvioPadrao: desvioPadrao.toFixed(2),
    coeficienteStudent: student.toFixed(3),
    fpkEstimado: fpkEstimado.toFixed(1),
  };
}
